import {
  DCPCustomerClassificationDTO,
  DCPPartialOrderDTO,
  DCPVendorDTO,
  DCPWheelSetOrderInfoDTO,
  SMSAddress,
  SMSCart,
  SMSDeliveryMode,
  SMSOrderEntry,
  SMSPaymentDetails,
  SMSPaymentModeDTO,
  SMSPointOfService,
  SMSPrice,
  SMSProduct,
} from '@dh-io-emh/commerce-api/src/models/shared/ocb/api.schema';
import Vehicle from './vehicle.model';

export enum PaymentMode {
  FinancialService = 'FINANCIAL_SERVICE',
  DirectPayment = 'DIRECT_PAYMENT',
  OtherPayment = 'OTHER_PAYMENT',
}

export default class Cart {
  chargedNow?: SMSPrice;
  code: string;
  contactAddress?: SMSAddress;
  dcpCustomerClassification?: DCPCustomerClassificationDTO;
  deliveryAddress?: SMSAddress;
  deliveryCost?: SMSPrice;
  deliveryMode?: SMSDeliveryMode;
  downstreamPaymentMode: PaymentMode;
  financialCalculatorProductType?: 'LEASING' | 'FINANCING';
  financialCalculatorStorageId?: string;
  guid: string;
  net: boolean;
  partialOrderList: PartialOrder[];
  paymentAddress?: SMSAddress;
  paymentMode?: SMSPaymentModeDTO;
  paymentInfo?: SMSPaymentDetails;
  pickupPointOfService?: SMSPointOfService;
  totalPriceWithTax?: SMSPrice;

  constructor(data: SMSCart) {
    this.chargedNow = data.chargedNow;
    this.code = data.code as string;
    this.contactAddress = data.contactAddress;
    this.deliveryCost = data.deliveryCost;
    this.deliveryMode = data.deliveryMode;
    this.deliveryAddress = data.deliveryAddress;
    this.guid = data.guid as string;
    this.net = data.net as boolean;
    this.financialCalculatorStorageId = data.financialCalculatorStorageId;
    this.financialCalculatorProductType = data.financialCalculatorProductType;
    this.partialOrderList =
      data.partialOrderList?.map((partialOrder) => new PartialOrder(partialOrder as DCPPartialOrderDTO)) ?? [];
    this.paymentAddress = data.paymentAddress;
    this.paymentInfo = data.paymentInfo;
    this.paymentMode = data.paymentMode;
    this.pickupPointOfService = data.pickupPointOfService;
    this.downstreamPaymentMode = data.downstreamPaymentMode as PaymentMode;
    this.totalPriceWithTax = data.totalPriceWithTax;
    this.dcpCustomerClassification = data.dcpCustomerClassification;
  }

  static create(data: SMSCart) {
    return new Cart(data);
  }
}

class PartialOrder {
  entries: OrderEntry[];
  vendor: DCPVendorDTO;
  deliveryMode: SMSDeliveryMode;

  constructor(data: DCPPartialOrderDTO) {
    this.entries = data.entries?.map((entry) => new OrderEntry(entry as SMSOrderEntry)) ?? [];
    this.vendor = data.vendor as DCPVendorDTO;
    this.deliveryMode = data.deliveryMode as SMSDeliveryMode;
  }
}

class OrderEntry {
  product: Vehicle;
  productPrice: SMSPrice | undefined;
  deliveryPointOfService: SMSPointOfService;
  quantity?: number;
  wheelSetOrderInfo?: DCPWheelSetOrderInfoDTO;
  freezeId?: string;

  constructor(data: SMSOrderEntry) {
    this.product = Vehicle.create(data.product as SMSProduct);
    this.productPrice = data.productPrice;
    this.deliveryPointOfService = data.deliveryPointOfService as SMSPointOfService;
    this.quantity = data.quantity;
    this.wheelSetOrderInfo = data.wheelSetOrderInfo;
    this.freezeId = data.freezeId;
  }
}
